module.exports = __webpack_public_path__ + "static/isotipo-96c161d8c89bd3551e29ff75680ca388.png";